
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  height:100%;
}

:host([active]) .list-flyout{
    border-color:var(--color-primary-default);
  }

:host([active]) .list-flyout--button{
    position:relative;
  }

:host([active]) .list-flyout--button::after{
      content:'';
      width:100%;
      height:3px;
      background-color:var(--color-primary-default);
      top:0;
      left:0;
      position:absolute;
    }

ul{
  margin:0;
  padding:0;
  list-style:none;
}

li{
  list-style:none;
}

a{
  text-decoration:none;
  color:unset;
}

.list-flyout{
  display:flex;
  align-items:center;
  height:100%;
  width:100%;
  border-top:solid 3px transparent;
}

.list-flyout.pseudo-focus{
    background-color:var(--color-blue-100);
  }

.list-flyout:hover{
    border-top:solid 3px var(--color-primary-default);
  }

.list-flyout--link{
  color:var(--color-neutral-dark);
  text-decoration:none;
  padding:0 0.25rem;
}

.list-flyout[engaged]{
  background-color:var(--color-blue-100);
}

.list-flyout[engaged] > span,
.list-flyout[engaged] > a{
  color:var(--color-neutral-dark);
}

.list-flyout.open > .list-flyout--sub-menu{
  display:flex;
}

.list-flyout--button{
  display:flex;
  background:none;
  border:none;
  align-items:center;
  max-width:-moz-fit-content;
  max-width:fit-content;
  padding:1rem 0.5rem;
  column-gap:0.5rem;
  height:100%;
  cursor:pointer;
}

.list-flyout--button:focus:not(:active){
    outline:none;
  }

.list-flyout--button:focus-visible{
    outline:solid var(--color-primary-default) 2px !important;
    outline-offset:-2px;
  }

.list-flyout--label{
  margin:0;
  font-weight:var(--fw-bold);
  color:var(--color-neutral-dark);
}

.list-flyout--label,
.list-flyout--link{
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.list-flyout--link-main{
  position:absolute;
  top:3rem;
  margin-bottom:2.5rem;
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
  font-weight:700;
}

.list-flyout--link-main a{
    display:flex;
    color:var(--color-primary-default);
    align-items:center;
    column-gap:0.75rem;
  }

.list-flyout--link-main a:hover{
      text-decoration:underline;
    }

.list-flyout--sub-menu{
  position:absolute;
  top:123px;
  left:0;
  display:none;
  flex-wrap:wrap;
  width:100%;
  padding:3rem 7%;
  column-gap:5%;
  list-style:none;
  background-color:var(--color-blue-100);
  z-index:1;
}

.list-flyout--sub-menu li{
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
    font-weight:700;
  }

.list-flyout--sub-menu li ul,
    .list-flyout--sub-menu li ul.columns{
      margin-top:1rem;
      display:grid;
      row-gap:0.25rem;
    }

.list-flyout--sub-menu li ul li, .list-flyout--sub-menu li ul.columns li{
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        font-weight:400;
      }

.list-flyout--sub-menu li ul li a, .list-flyout--sub-menu li ul.columns li a{
          color:var(--color-gray-400);
        }

.list-flyout--sub-menu li ul.columns{
      justify-content:space-between;
      grid-template-columns:1fr 1fr;
      column-gap:2rem;
    }

.list-flyout--sub-menu > li:not(.list-flyout--link-main){
    padding-top:3.75rem;
  }

.list-flyout--button-icon{
  pointer-events:none;
}
`;